/** 本机 novelId → 云端 project 绑定（clientVersion 缓存） */
const KEY = 'thesis-cloud-map-v1'

export type CloudBinding = {
  projectId: string
  clientVersion: number
  updatedAt?: string
}

type MapFile = Record<string, CloudBinding>

function load(): MapFile {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return {}
    return JSON.parse(raw) as MapFile
  } catch {
    return {}
  }
}

function save(m: MapFile) {
  localStorage.setItem(KEY, JSON.stringify(m))
}

export function getCloudBinding(localNovelId: string): CloudBinding | null {
  return load()[localNovelId] || null
}

export function setCloudBinding(localNovelId: string, b: CloudBinding) {
  const m = load()
  m[localNovelId] = b
  save(m)
}

export function clearCloudBinding(localNovelId: string) {
  const m = load()
  delete m[localNovelId]
  save(m)
}
